import * as React from "react";
import NavigationDropdown from "../navigation-dropdown/NavigationDropdown";
import LinkTag from "../../buttons/link-tag/LinkTag";
import AccountIcon from "/src/svg/account.svg";
import translate from "/src/utils/translate";

import * as styles from "./sign-in-selector.module.scss";
import {css} from "/src/utils/utils";
import Icon from "../../icon/Icon";
import {LOCALE} from "/src/config";

interface SignInOption {
  label: string;
  url: string;
}

const SignInOptions: Array<SignInOption> = [
  {
    label: translate("Forwarding"),
    url: "https://app.flexport.com/users/sign_in",
  },
  {label: translate("Fulfillment"), url: "https://login.portal.flexport.com/"},
];

export default function SignInSelector() {
  if (LOCALE !== "en-US") {
    return (
      <div>
        <LinkTag
          href="https://app.flexport.com"
          openInNewTab
          classes={styles.signInSelector__linkButton}
        >
          <Icon
            svg={AccountIcon}
            role="presentation"
            classes={styles.signInSelector__icon}
          />
          {translate("Sign In")}
        </LinkTag>
      </div>
    );
  }

  return (
    <NavigationDropdown
      leftIconSvg={AccountIcon}
      numberOfItems={SignInOptions.length}
      label={translate("Sign In")}
    >
      {(focusedListItem: number) =>
        SignInOptions.map(({label, url}, index) => {
          const hasFocus = focusedListItem === index;
          return (
            <LinkTag
              key={label}
              href={url}
              openInNewTab
              classes={css(
                styles.signInSelector__link,
                hasFocus ? styles.signInSelector__linkFocus : ""
              )}
            >
              {label}
            </LinkTag>
          );
        })
      }
    </NavigationDropdown>
  );
}
